import { CHAT_MODAL_HIDE } from 'moduleChat/modules/modal/constants';

var chatModalHide = function chatModalHide() {
  return {
    type: CHAT_MODAL_HIDE
  };
};

export { chatModalHide };